(function ($) {

    $.nette.init();
    
    var $header = $('.header');
    var headerHeight = $header.height();

    $('html').removeClass('loading').addClass('js');

    if (isMobile.any)
        $('html').addClass('is-mobile')

    smoothScroll.init({offset: headerHeight});

    // google font
    WebFontConfig = {
        google: {families: ['Roboto:400,300,100,500:latin,latin-ext']}
    };
    (function () {
        var wf = document.createElement('script');
        wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
        wf.type = 'text/javascript';
        wf.async = 'true';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(wf, s);
    })();
    // end google font


    $('.claim').animateCSS();
    $('.teaser-nav li').animateCSS({delay: 700});

    if (isMobile.any)
        $('.teaser-mobile').animateCSS({delay: 400})

    var appearDistance = '90%';

    // section 2
    if ($('#section-2-why-gennet')[0]) {
        var whyGennetWaypoint = new Waypoint({
            element: $('#section-2-why-gennet'),
            handler: function (direction) {
                $('#section-2-why-gennet').animateCSS();
                $('#section-2-why-gennet li').animateCSS({delay: 100, stepDelay: 100})
            },
            offset: appearDistance
        });
    }
    // end section 2


    // section 3
    if ($('#section-3-trying')[0]) {
        var tryingWaypoint = new Waypoint({
            element: $('#section-3-trying'),
            handler: function (direction) {
                $('#section-3-trying').animateCSS();
                $('#section-3-trying > img').animateCSS({delay: 200});
                $('#section-3-trying .inner').animateCSS({style: 'fadeInLeft', delay: 700});
            },
            offset: appearDistance
        });
    }
    // end section 3


    // section 4
    if ($('#section-4-clinic')[0]) {
        var clinicWaypoint = new Waypoint({
            element: $('#section-4-clinic'),
            handler: function (direction) {
                $('#section-4-clinic').animateCSS();
            },
            offset: appearDistance
        });
    }

    if ($('.gallery')[0]) {
        var galleryWaypoint = new Waypoint({
            element: $('.gallery'),
            handler: function (direction) {
                $('.gallery a').animateCSS({stepDelay: 200});
            },
            offset: '75%'
        });
    }

    // end section 4
    function loadFrmCallbackInterestDoctors(frmCallbackFormInterest, firstLoad) {
        var changeUrl = frmCallbackFormInterest.data('load-doctor-url'),
            firstOprion = frmCallbackFormInterest.data('first-element-text'),
            interestId = frmCallbackFormInterest.val();

        $.get(changeUrl, {'interestId': interestId}, function (data) {
            if (data.status === 'OK') {
                var selectHtml = '<option value="">' + firstOprion + '</option>';

                $.each(data.list, function (key, value) {
                    selectHtml += '<option value="' + key + '">' + value + '</option>';
                });

                var doctorVal = $('#frm-callbackForm-doctor').val();

                $('#frm-callbackForm-doctor').html(selectHtml);

                if (doctorVal && firstLoad) {
                    $('#frm-callbackForm-doctor').val(doctorVal);
                }

                $('.doctor').show();
            } else {
                $('#frm-callbackForm-doctor').html('');
                $('.doctor').hide();
            }
        });
    }

    var frmCallbackFormInterest = $('#frm-callbackForm-interest');
    frmCallbackFormInterest.change(function () {
        loadFrmCallbackInterestDoctors($(this), false);

        if ($(this).val() == 36) {
            $('.prefer-contact').hide();
        } else {
            $('.prefer-contact').show();
        }
    });

    if (frmCallbackFormInterest.length > 0) {
        loadFrmCallbackInterestDoctors(frmCallbackFormInterest, true);
    }

    // section 5
    var carouselTestimonial = $('.carousel-testimonial');
    var isCarouseOn = false;

    if ($('#section-5-testimonial')[0]) {
        var testimonialWaypoint = new Waypoint({
            element: $('#section-5-testimonial'),
            handler: function (direction) {

                if (isCarouseOn) return;

                carouselTestimonial.slick({
                    adaptiveHeight: true,
                    fade: true,
                    cssEase: 'linear'
                });

                $('#section-5-testimonial').animateCSS({delay: 400});

                isCarouseOn = true;
            },
            offset: appearDistance
        });
    }
    // end section 5

    // section 6
    if ($('#section-6-team')[0]) {
        var teamWaypoin = new Waypoint({
            element: $('#section-6-team'),
            handler: function (direction) {
                if ($('#videoCEO').length) {
                    $('#videoCEO').get(0).play();
                    this.destroy();
                }
            },
            offset: '50%'
        });
    }
    // end section 6

    // carousel events
    carouselTestimonial.on('init', function () {
        var $currentSlide = carouselTestimonial.find('.slick-active');
        setTimeout(function () {
            animateInsideSlide($currentSlide);
        }, 1000);
    });

    carouselTestimonial.on('afterChange', function (event, slick, currentSlide) {
        var $currentSlide = $('[data-slick-index = ' + currentSlide + ']');

        animateInsideSlide($currentSlide);
    });

    carouselTestimonial.on('beforeChange', function () {
        carouselTestimonial.find('.fadeInUp').removeClass('fadeInUp animated');
        carouselTestimonial.find('.fadeInRight').removeClass('fadeInRight animated');
    });

    function animateInsideSlide(actualSlide) {
        actualSlide.find('.pretext')
            .animateCSS();

        actualSlide.find('h2')
            .animateCSS({delay: 200});

        actualSlide.find('p')
            .animateCSS({delay: 400});

        actualSlide.find('.buttons')
            .animateCSS({delay: 800});

        actualSlide.find('figure')
            .animateCSS({style: 'fadeInRight', delay: 400})

    }

    // end carousel events

    // dropdown
    $('.dropdown-toggle').on('click', function (e) {
        e.preventDefault();

        $(this).toggleClass('open');
    });


    // burger menu
    $(document).on('click', '#burger-button', function () {
        $(this).toggleClass('open');
    });
    // end burger menu


    // search focus
    // $('.search-wrap').hover(function(){
    //     setTimeout(function(){
    //     }, 100);
    //   }, function(){
    //     $('.search-wrap input').blur();
    //   });

    $(document)
        .on('click', '.search-wrap', function () {
            $('#search').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function (e) {
                $(this).focus();
            });
            $(this).addClass('active');
        })
        .on('click', function (e) {
            if ($(e.target).closest('.search-wrap').length) return;
            $('.search-wrap').removeClass('active');
            $('#search').focusout();
        });
    // end search focus


    // number count
    $('.count').each(function () {
        $(this).prop('Counter', 0).animate({
            Counter: $(this).text()
        }, {
            duration: 5000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });
    // end number count

    // google maps waypoints
    var mapWaypoint = $('.map').waypoint({
        handler: function (direction) {

            googlemaps.init('tabs__content', 'google-map-holder');

            if ($('#google-street').attr('src') == null) {
                $('#google-street').attr('src', $('#google-street').attr('data-src'));
            }

            this.disable();
        },
        offset: '150%',
    });

    var navs = $('.tabs__nav');
    navs.on('click', function (e) {
        e.preventDefault();
        googlemaps.init('tabs__content', 'google-map-holder');
    });
    $(window).resize(function () {
        if ($(".google-map-holder").length) {
            googlemaps.init('tabs__content', 'google-map-holder');
        }
    });

    var navsTeam = $('.our-team').find('.tabs [data-tab-nav]');
    navsTeam.on('click', function (e) {
        e.preventDefault();
        readMore.hideFullVersion();
    });

    //gallery
    $('.gallery:not(.gallery-no-plus)').each(function () { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a', // the selector for gallery item
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });
    //end gallery


    // VerticalSlider init
    var vs = $('.vertical-slider');
    if (vs.length) {
        $.each(vs, function () {
            Slider.init($(this));
        });
    }

    // footer headline height / box aligment
    function alignFooterBoxes() {
        var $footer = $('.footer');
        if ($footer.length) {
            var $headlines = $footer.find('.box > h2');
            if ($headlines.length) {
                $headlines.css('height', '');
                var max = 0;
                for (var i = 0; i < $headlines.length; i++) {
                    var $h = $($headlines[i]);
                    max = ($h.innerHeight() > max) ? $h.innerHeight() : max;
                }

                $headlines.css('height', max + 'px');
            }
        }
    }

    alignFooterBoxes();

    $(window).on('resize', function () {
        alignFooterBoxes();
    });


    // CEO video
    function ceoVideoInit(video, placeholder) {
        var pl = $(placeholder);
        if (pl.length) {
            pl.append(
                '<video id="videoCEO" class="video--ceo" pposter="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" style="visibility:hidden;" onplay="var s=this;setTimeout(function(){s.style.visibility=\'visible\';},100);">' +
                '    <source src="' + video + '.mp4" type="video/mp4">' +
                '</video>');
        }
    }

    if (window.matchMedia("(min-width: 768px)").matches && $('#section-6-team').length) {
        ceoVideoInit('www/videos/kavkova-1600x750-mensi', '#videoCeo');
    }


    // homepage scroll by hashtag
    if (document.location.hash.length) {
        var hash = document.location.hash.substring(1);

        // prevent jumb down
        setTimeout(function () {
            window.scrollTo(0, 0);
        }, 1);

        setTimeout(function () {
            smoothScroll.animateScroll(document.location.hash, null, {offset: 100});
        }, 200);


    }

    $(".fancybox").fancybox();

    $(".fancybox-thumb").fancybox({
        // prevEffect	: 'none',
        // nextEffect	: 'none',
        helpers: {
            // title	: {
            //     type: 'outside'
            // },
            buttons: {},
            thumbs: {
                width: 50,
                height: 50
            }
        }
    });
}(jQuery));


$('.fr-home__slider').slick({
    //adaptiveHeight: true,
    fade: true,
    cssEase: 'linear',
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                autoplaySpeed: 3000
            }
        }
    ]
});

/*$('.fr-home__slider').slick({
  dots: true,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear'
});*/